import { Config } from '@/config';
import BaseApiService from '@/api/base-api-service';
import { MerchantDetailsModel } from '@/models/MerchantDetailsModel';
import { MerchantDetailsRawModel } from '@/api/api-raw-models/merchant-details-raw-model';
import { mapMerchant, mapMerchantDetails } from '@/api/mappers/map-response';
import { MerchantListRawModel } from '@/api/api-raw-models/merchant-raw-model';
import { MerchantModel } from '@/models/MerchantModel';
import { MerchantsRequest } from '@/types';

export class MerchantApiService extends BaseApiService {
  private readonly merchantsPrefix = 'merchants';

  public async getMerchantById(merchantId: number): Promise<MerchantDetailsModel> {
    const url = `${Config.ApiUrl}/${this.merchantsPrefix}/detail/${merchantId}`;

    const res = await fetch(url, {
      method: 'GET',
      headers: this.headers,
    });

    return this.mapResponse<MerchantDetailsRawModel, MerchantDetailsModel>(res, mapMerchantDetails);
  }

  public async getMerchantsPage(req?: MerchantsRequest): Promise<MerchantModel[]> {
    const url = `${Config.ApiUrl}/${this.merchantsPrefix}/app-list`;
    const body = {};
    if (req) {
      const {
        lat, lon, page, limit,
      } = req;
      if (lat) Object.assign(body, { lat });
      if (lon) Object.assign(body, { lon });
      if (page) Object.assign(body, { page });
      if (limit) Object.assign(body, { limit });
    }

    const res = await fetch(url, {
      method: 'POST',
      headers: this.headers,
      body: JSON.stringify(body),
    });

    return this.mapResponse<MerchantListRawModel, MerchantModel[]>(res, (resp) => resp.merchants.map(mapMerchant));
  }
}
